<ng-template #provisionModalFormContent role="document" let-modal>

  @if(!embeddedFormMode) {
    <app-modal-comp-header
      [title]="formTitle"
      (cancelButtonOnClick)="closeForm(); modal.dismiss('Cross click')"
    ></app-modal-comp-header>
  }

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">

    <form [formGroup]="provisioningForm" class="tablelist-form" autocomplete="off" name="no-autofill-form">
      <div class="modal-body">

        @if(mustHaveLicence) {
          <div class="licence-container">
            <div class="licence-header">
              <div class="licence-left">
                <div
                  class="status-dot"
                  [ngClass]="{
                    'dot-green': totalRemainingLicences > 10,
                    'dot-yellow': totalRemainingLicences > 3 && totalRemainingLicences <= 10,
                    'dot-red': totalRemainingLicences <= 3
                  }"
                ></div>
          
                <span class="licence-text">
                  <strong>{{ selectedInviewCompany?.description ?? "" }}</strong> —
                  {{ totalPlatformLicences }} licences,
                  {{ totalLiveDevices }} used,
                  <strong
                    [ngClass]="{
                      'text-green': usedLicencePercentage < 90,
                      'text-red': usedLicencePercentage >= 90
                    }"
                  >
                    {{ totalRemainingLicences }} remaining
                  </strong>
                </span>
              </div>
          
              <span class="order-status">Order Status: <span [innerHtml]="orderStatusInformation" ></span></span>
            </div>
          
            <div class="progress-bar">
              <div
                class="progress-fill"
                [ngStyle]="{
                  width: usedLicencePercentage + '%',
                  background:
                    usedLicencePercentage > 90
                      ? '#FF3B5C'
                      : usedLicencePercentage > 70
                      ? '#FFD166'
                      : 'linear-gradient(90deg, #06D6A0, #38BDF8)'
                }"
              ></div>
            </div>
          </div>
        } @else {
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                  <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                  <span [innerHtml]="progressInformation"></span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="alert border-0 {{alertColourOrderStatus}}" role="alert">
                  <strong>Order Status</strong> - <span [innerHtml]="orderStatusInformation" ></span>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="provisioning-card">
          <div class="row">
            <div class="col-6">
              <div class="mb-3 ml-20 mt-14">
                <label for="inviewCompanyId-field" class="form-label text-right required">Company</label>
                <div class="input-group">
                  <select
                    autocomplete="off"
                    class="form-select"
                    name="inviewCompanyId-field"
                    id="inviewCompanyId-field"
                    formControlName="inviewCompanyId"
                    (change)="inviewCompanySelectDropDownChange($event)"
                    [ngClass]="{ 'is-invalid': formSubmitted && formData['inviewCompanyId'].errors }"
                  >
                    <option selected></option>
                    @for (object of getDropdownDataObjectArray("inviewCompanyId"); track object.id) {
                      <option [ngValue]="object.id">{{object.description}}</option>    
                    }
                  </select>
                  @if(registerInviewCompany) {
                    <button class="btn btn-danger" type="button" [disabled]="!addCompanyButtonEnabled" (click)="addInviewCompany()">Register</button>
                  } @else {
                    <button class="btn btn-success" type="button" [disabled]="!addCompanyButtonEnabled" (click)="addInviewCompany()">Add</button>
                  }
                  <div class="invalid-feedback">A value is required</div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3 mr-20 mt-14">
                <label for="inviewUserId-field" class="form-label text-right required">User</label>
                <div class="input-group">
                  <div class="input-group">
                    <select
                      autocomplete="off"
                      class="form-select"
                      name="inviewUserId-field"
                      id="inviewUserId-field"
                      formControlName="inviewUserId"
                      (change)="inviewUserSelectDropDownChange($event)"
                      [ngClass]="{ 'is-invalid': formSubmitted && formData['inviewUserId'].errors }"
                    >
                      <option selected></option>
                      @for (object of getDropdownDataObjectArray_InviewUser(); track object.userID) {
                        <option [ngValue]="object.userID">{{getInviewUserLabel(object)}}</option>
                      }
                    </select>
                    @if(registerInviewUser) {
                      <button class="btn btn-danger" type="button" [disabled]="!addUserButtonEnabled" (click)="addInviewUser()">Register</button>
                    }
                    
                    @if(searchForInviewUser) {
                      <button class="btn btn-success" type="button" (click)="_searchForInviewUser()">Search for User</button>
                    }
                    
                    @if(!registerInviewUser && !searchForInviewUser) {
                      <button class="btn btn-success" type="button" [disabled]="!addUserButtonEnabled" (click)="addInviewUser()">Add</button>
                    }
                    <div class="invalid-feedback">A value is required</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="row">
            <div class="col-6">
              <div class="mb-3 ml-20">
                <label for="deviceTypeId-field" class="form-label text-right required">Sim Type</label>
                <div class="input-group">
                  <select
                    autocomplete="off"
                    class="form-select"
                    name="deviceTypeId-field"
                    id="deviceTypeId-field"
                    formControlName="deviceTypeId"
                    (change)="deviceTypeSelectDropDownChange($event)"
                    [ngClass]="{ 'is-invalid': formSubmitted && formData['deviceTypeId'].errors }"
                  >
                    <option selected></option>
                    @for (object of getDropdownDataObjectArray("deviceTypeId"); track object.id) {
                      <option [ngValue]="object.id">{{object.description}}</option>    
                    }
                  </select>
                  <div class="invalid-feedback">A value is required</div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3 mr-20">
                <label for="productId-field" class="form-label text-right required">Product</label>
                <select autocomplete="off" class="form-select" name="productId-field" id="productId-field" formControlName="productId" (change)="productSelectDropDownChange($event)" [ngClass]="{ 'is-invalid': formSubmitted && formData['productId'].errors }">
                  <option selected></option>
                  @for (object of getDropdownDataObjectArray("productId"); track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>    
                  }
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
  
          @if(physicalSimSelected == false && userSelected() && productSelected() && (totalRemainingLicences > 0 || !mustHaveLicence)) {
  
            <div class="labeled-divider mb-3 mt-3 ml-20 mr-20">
               <span class="divider-label">Delivery Method</span>
            </div>
  
            <div class="delivery-grid ml-20 mr-20" [ngClass]="{ 'cols-3': !showManualProvisioningButton }">
              <ng-container *ngFor="let m of deliveryMethods">
                <button
                  *ngIf="m.id !== 'manual' || showManualProvisioningButton"
                  class="delivery-button"
                  [ngClass]="{
                    'selected': deliveryMethod === m.id
                  }"
                  (click)="selectMethod(m.id)"
                >
                  <div class="icon">{{ m.icon }}</div>

                  <div class="label" [ngClass]="{ 'label-selected': deliveryMethod === m.id }">
                    {{ m.label }}
                  </div>

                  <div class="desc">
                    {{ m.desc }}
                  </div>
                </button>
              </ng-container>
            </div>
  
<!-- Device Type -->
            @if((deliveryMethod === 'sms' || deliveryMethod === 'email') && (totalRemainingLicences > 0 || !mustHaveLicence)) {
              <div class="labeled-divider mb-3 mt-3 ml-20 mr-20">
                <span class="divider-label">Device Type</span>
              </div>
              <div [ngClass]="{ 'device-grid-3-columns' : deliveryMethod === 'email', 'device-grid-2-columns ml-20 mr-20' : deliveryMethod === 'sms'}">
                @for (d of filteredDeviceTypes; track d.id) {
                  <button
                    class="device-btn"
                    [ngClass]="{ selected: deviceType === d.id }"
                    (click)="setDeviceType(d.id)"
                  >
                    <div class="icon">{{ d.icon }}</div>

                    <div
                      class="device-label"
                      [ngClass]="{ 'label-selected': deviceType === d.id }"
                    >
                      {{ d.label }}
                    </div>

                    <div class="device-desc">
                      {{ d.desc }}
                    </div>
                  </button>
                }
              </div>
            }

<!-- Sending To -->
            @if(sendingToVisible()) {
              <div class="sending-to ml-20 mr-20">
                <div class="sending-to-label">{{ deliveryMethod === 'manual' ? 'Your contact information' : 'Sending to' }}</div>

                <div class="sending-to-value" [ngClass]="{ 'sending-to-missing': sendingToMissing() }">
                  <i class="me-2 align-middle" [ngClass]="deliveryMethod === 'sms' ? 'ri-smartphone-line' : 'ri-mail-line'"></i>{{ sendingToMissing() ? 'Not set' : sendingToValue() }}
                </div>

                <div class="sending-to-help" [ngClass]="{ 'sending-to-help-warning': sendingToMissing() }">{{ sendingToDescription() }}</div>
              </div>

<!-- Customise Message -->
              @if(customiseMessageVisible()) {
                <app-customise-message
                  class="ml-20 mr-20"
                  footerText="Saved to your company message template when you provision"
                  idPrefix="customisemessage"
                  [canEdit]="canEditCustomiseMessage"
                  [defaultText]="customiseMessageResetText()"
                  [(expanded)]="customiseMessageExpanded"
                  [replacements]="customiseMessageReplacements"
                  [title]="customiseMessageTitle"
                  [(value)]="customiseMessageBody"
                  (expandedChange)="onCustomiseMessageExpandedChange($event)"
                ></app-customise-message>
              }
            }
          } 
  
          <div class="row" [hidden]="physicalSimSelected == undefined || (physicalSimSelected == false && randomEsim == true)">
            <div class="col-12">
              <div class="mb-3 ml-20 mr-20">
                <label for="deviceId-field" class="form-label text-right required">ICCID</label>
                <div class="input-group"> 
                  
                  <ng-select
                    autocomplete="off"
                    id="deviceId-field"
                    class="w-100"
                    appendTo="body"
                    [items]="getDropdownDataObjectArray('deviceId')"
                    bindLabel="description"
                    bindValue="id"
                    [searchable]="true"
                    [clearable]="true"
                    [loading]="!noICCIDData && !getDropdownDataObjectArray('deviceId')?.length"
                    [placeholder]="noICCIDData == true ? 'No SIMs Found' : 'Search ICCID…'"
                    formControlName="deviceId"
                    (change)="deviceSelectDropDownChange($event)"
                    [ngClass]="{ 'is-invalid': formSubmitted && formData['deviceId'].errors }">
                  </ng-select>
  
                  @if(formData["deviceId"].hasError("alreadyProvisioned")) {
                    <div class="invalid-feedback">Please select different ICCID, this one is no longer available</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
               </div>
             </div>
           </div>
           
          <div hidden class="row">
            <div class="col-12">
              <div class="mb-3">
                <label hidden for="iccid-field" class="form-label text-right required">ICCID</label>
                <input autocomplete="off" hidden type="text" id="iccid-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="iccid" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formData['iccid'].errors }" />
              </div>
            </div>
          </div>
  
          <div class="row" [hidden]="(physicalSimSelected == undefined || physicalSimSelected == true) || !userSelected() || !productSelected() || (deliveryMethod === '' || deliveryMethod === 'sms' || deliveryMethod === 'email' || deliveryMethod === 'manual')">
            <div class="col-12">
              <div class="mb-3 ml-20 mr-20">
                <label for="eid-field" class="form-label text-right required">EID</label>
                <input #eidfield
                  autocomplete="off"
                  class="form-control text-start"
                  [ngClass]="{ 'is-invalid': formData['eid'].errors && (formData['eid'].value != '' || formSubmitted) }"
                  data-lpignore="true"
                  formControlName="eid"
                  id="eid-field"
                  placeholder="Enter 32-digit EID..."
                  [readonly]="preventAutofill"
                  type="text"
                  (mousedown)="preventAutofill=false; ($any($event.target)).readOnly=false; ($any($event.target)).focus()"
                />
                @if(formData["eid"].hasError("minlength") || formData["eid"].hasError("maxlength")) {
                  <div class="invalid-feedback">EID must be 32 digits in length</div>
                } @else if(formData["eid"].hasError("pattern")) {
                  <div class="invalid-feedback">EID must contain number characters only</div>
                } @else {
                  <div class="invalid-feedback">A value is required</div>
                }
              </div>
            </div>
          </div>
  
<!-- Device-Specific Note -->
          <div *ngIf="deliveryMethod != '' && deliveryMethod !== 'manual' && !((deliveryMethod === 'sms' || deliveryMethod === 'email') && deviceType === '') && (totalRemainingLicences > 0 || !mustHaveLicence) && (physicalSimSelected == undefined || physicalSimSelected == false)"
            class="device-note ml-20 mr-20"
            [ngStyle]="{
              background: deviceType === 'ios'
                ? 'rgba(0,122,255,0.04)'
                : deviceType === 'android'
                ? 'rgba(61,220,132,0.04)'
                : 'rgba(0,120,212,0.04)',
              border: deviceType === 'ios'
                ? '1px solid rgba(0,122,255,0.12)'
                : deviceType === 'android'
                ? '1px solid rgba(61,220,132,0.12)'
                : '1px solid rgba(0,120,212,0.12)'
            }"
          >
            <div
              class="note-title"
              [ngClass]="{
                ios: deviceType === 'ios',
                android: deviceType === 'android',
                windows: deliveryMethod === 'email' || deliveryMethod === 'eid'
              }"
            >
              {{
                deviceType === 'ios'
                  ? 'iOS Installation'
                  : deviceType === 'android'
                  ? 'Android Installation'
                  : deliveryMethod === 'email' 
                  ? 'Windows Installation'
                  : 'EID Installation'
              }}
            </div>
        
            <div class="note-text">
              {{
                deviceType === 'ios'
                  ? 'Link will open Settings → Cellular → Add eSIM automatically. Requires iOS 16+ and an eSIM-compatible iPhone (XS or later).'
                  : deviceType === 'android'
                  ? 'Link will trigger the native eSIM activation flow. Requires Android 10+ with eSIM support. Samsung devices use Samsung eSIM Manager.'
                  : deliveryMethod === 'email'
                  ? 'Link will open Settings → Network & Internet → Cellular → Add eSIM. Requires Windows 11 with eSIM-capable hardware.'
                  : 'eSIM will be pushed directly to the device via EID. No user action required.'
              }}
            </div>
          </div>
  
<!-- Manual Activation Details -->
          <div *ngIf="manualActivationDetailsVisible && deliveryMethod === 'manual'" class="manual-activation ml-20 mr-20">
            <div class="note-title ios">Activation Details</div>

            <div class="manual-activation-row">
              <span class="manual-activation-label">Activation Server</span>
              <span class="manual-activation-value">{{ manualActivationServer }}</span>
              <button type="button" class="btn btn-soft-success btn-sm" (click)="copyToClipboard(manualActivationServer)">Copy</button>
            </div>

            <div class="manual-activation-row">
              <span class="manual-activation-label">Activation Code</span>
              <span class="manual-activation-value">{{ manualActivationCode }}</span>
              <button type="button" class="btn btn-soft-success btn-sm" (click)="copyToClipboard(manualActivationCode)">Copy</button>
            </div>
          </div>

          <div class="labeled-divider mb-6 mt-3 ml-20 mr-20">
            <span class="divider-label"></span>
          </div>

          <div class="row">
            <div class="col-12 mb-3 mr-20">
              <div class="hstack gap-2 justify-content-end mr-20">
                @if(!embeddedFormMode) {
                <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm();modal.close('Close click')">Close</button>
                }
                @if(manualActivationDetailsVisible) {
                <button type="button" class="btn btn-danger" id="reset-btn" (click)="resetManualForm()">Reset Form</button>
                }
                <button type="submit" class="btn btn-success" id="add-btn" [disabled]="!isProvisionButtonEnabled()" (click)="saveFormData()">{{getProvisionButtonText()}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>

  <app-spinner-overlay-wrapper #spinnerOverlayWrapperComponent
    [showSpinner]="this.provisioningInProgress"
  ></app-spinner-overlay-wrapper>

</ng-template>

<app-company-modal-form #companyModalForm
  [inputInviewCompanyId]="this.selectedInviewCompanyId"
  (inviewCompanyDataHasBeenSaved)="inviewCompanyHasBeenSaved($event)"
></app-company-modal-form>
  
<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-user-modal-form #userModalForm
  [forceCreateNewUser]="!registerInviewUser"
  [initialInviewCompanyId]="selectedInviewCompanyId"
  [inputInviewUserId]="selectedInviewUserId"
  [lockCompanyDropDown]="true"
  (inviewUserDataHasBeenSaved)="inviewUserDataHasBeenSaved($event)"
></app-user-modal-form>

<app-user-modal-form-search #userSearchForm
  [portalUsers]="undefined"
  (searchFormCancelled)="searchFormCancelled()"
  (searchFormHasBeenSaved)="searchFormHasBeenSaved()"
  (searchGridRowClick)="searchGridRowClick($event)"
  (searchGridRowDblClick)="searchGridRowClick($event)"
></app-user-modal-form-search>
  
<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
